import styled from "styled-components";
export const ArchiveDocumentListWrapper = styled.div`
  .cell-documentName {
    min-width: 400px;
  }
  .cell-status {
    min-width: 165px;
  }
  .cell-notes {
    min-width: 200px;
  }

  .badge-status {
    white-space: nowrap;
  }
  .document-name-link {
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .document-type {
    text-transform: capitalize;
  }
`;
